import {
  QButton,
  QModal,
  QModalActions,
  QModalBody,
  QModalHeader,
  QText,
} from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

export interface DeleteEntityModalProps {
  isOpen: boolean;
  isDeletingEntity: boolean;
  onCloseModal: () => void;
  deleteHandler: () => void;
  isDestructive?: boolean;
  modalText?: JSX.Element;
  entityName?: string;
}

export const DeleteEntityModal = ({
  isOpen,
  isDeletingEntity,
  onCloseModal,
  deleteHandler,
  isDestructive = true,
  modalText,
  entityName,
}: DeleteEntityModalProps) => {
  const { t } = useTranslation();
  const resolvedEntityName = entityName ?? t('labels.file');

  const defaultModalText = (
    <p>
      {t('modals.areYouCertainRemoveEntity', {
        entityName: resolvedEntityName,
      })}
    </p>
  );

  return (
    <QModal isOpen={isOpen} onClose={onCloseModal}>
      <QModalHeader>
        <QText>
          {t('buttons.delete')} {resolvedEntityName}
        </QText>
      </QModalHeader>
      <QModalBody>{modalText ?? defaultModalText}</QModalBody>
      <QModalActions>
        <QButton variant="outline" onClick={onCloseModal}>
          {t('buttons.cancel')}
        </QButton>
        {isDestructive ? (
          <QButton
            data-cy={'confirm-delete-button'}
            isDestructive
            isLoading={isDeletingEntity}
            onClick={deleteHandler}
          >
            {t('buttons.delete')}
          </QButton>
        ) : (
          <QButton
            data-cy={'confirm-delete-button'}
            isLoading={isDeletingEntity}
            onClick={deleteHandler}
          >
            {t('buttons.delete')}
          </QButton>
        )}
      </QModalActions>
    </QModal>
  );
};
